// extracted by mini-css-extract-plugin
export default {"examHeader":"ThinkingSkillsReview_examHeader__9+07d","indexRow":"ThinkingSkillsReview_indexRow__MT8ih","indexCircle":"ThinkingSkillsReview_indexCircle__WCd2p"};